// src/loom/space/types.ts
var LoomSpaceAriResourceOwner = "loom", LoomSpaceAriResourceType = "space";

export {
  LoomSpaceAriResourceOwner,
  LoomSpaceAriResourceType
};
